import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { type GetAllFaqsQueryParams, getAllFaqs } from '.';
import { get_all_faqs_query_key } from './query-key';
export const useGetAllFaqs = t0 => {
  const $ = _c(13);
  const {
    active,
    page: t1,
    quantity: t2,
    search
  } = t0;
  const page = t1 === undefined ? 1 : t1;
  const quantity = t2 === undefined ? 5 : t2;
  let t3;
  if ($[0] !== active || $[1] !== page || $[2] !== quantity || $[3] !== search) {
    t3 = get_all_faqs_query_key({
      active,
      page,
      quantity,
      search
    });
    $[0] = active;
    $[1] = page;
    $[2] = quantity;
    $[3] = search;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== active || $[6] !== page || $[7] !== quantity || $[8] !== search) {
    t4 = async () => await getAllFaqs({
      active,
      search,
      page,
      quantity
    });
    $[5] = active;
    $[6] = page;
    $[7] = quantity;
    $[8] = search;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = {
      queryKey: t3,
      queryFn: t4
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return useQuery(t5);
};